import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

import { InputGroup } from './InputGroup.entity';

export class MutateArticleGroups<T extends EMode = EMode.entity> {
  /** Alias: structure */
  structure?: InputGroup<T>[];

  __typename?: string;
}

const fields: FieldDefinitions<MutateArticleGroups> = {
  structure: {
    alias: 'structure',
  },
  __typename: {
    alias: '__typename',
  },
};

export const mutateArticleGroupsEntityDefinition: EntitiyDefinition<MutateArticleGroups> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'MutateArticleGroups',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
